import classNames from 'classnames';
import { Link } from 'react-router';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { set as setUiDictionary } from '../../../../../redux/actions/ui/dictionary';
import { delayedAapi } from '../../../../../services/analytics/aapi';
import SelectLot from '../../../../account/Lotslists/SelectLot';
import Follow from '../../../Follow';
import Links from '../../Links';
import './stylesheet.scss';
import Data from './Data';
import ViewCount from '../common/ViewCount';

const Square = ({ isAil, lot, auctioneerUrl, withSelectLot, urlTarget, reloadDocument }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (lot.imageUrl) {
      delayedAapi('lotimage', { idlot: lot.id, index: 0, op: 'list' });
    }
  }, [lot.imageUrl]);

  const handleClick = () => {
    dispatch(setUiDictionary('returnToIdlot', lot.id));
  };

  return (
    <div className={classNames({ 'lots-tile-access-square': true, ail: isAil })}>
      {isAil && <div className="encart encart-fr">Lot en Vedette</div>}
      {withSelectLot && <SelectLot id={lot.id} />}
      <Link to={urlTarget || lot.url} id={`lot-${lot.id}`} onClick={handleClick} reloadDocument={reloadDocument}>
        <Data lot={lot} isAil={isAil} />
      </Link>
      {/* Follow lot button */}
      <Follow idlot={lot.id} size="lg" />
      <Links saleUrl={!lot.isPast && lot.saleUrl} auctioneerUrl={auctioneerUrl} lotUrl={urlTarget || lot.url} />
      <ViewCount idlot={lot.id} />
    </div>
  );
};

export default Square;
